export function clearElement(element: HTMLElement): void {
  element.replaceChildren();
}

export function createElement<K extends keyof HTMLElementTagNameMap>(
  tagName: K,
  options?: {
    className?: string;
    textContent?: string;
    html?: string;
    attributes?: Record<string, string>;
  }
): HTMLElementTagNameMap[K] {
  const element = document.createElement(tagName);

  if (options?.className) {
    element.className = options.className;
  }

  if (options?.textContent !== undefined) {
    element.textContent = options.textContent;
  }

  if (options?.html !== undefined) {
    element.innerHTML = options.html;
  }

  if (options?.attributes) {
    for (const [key, value] of Object.entries(options.attributes)) {
      element.setAttribute(key, value);
    }
  }

  return element;
}

export function appendChildren(parent: HTMLElement, children: Array<Node | null | undefined>): void {
  for (const child of children) {
    if (child) {
      parent.appendChild(child);
    }
  }
}

export function queryRequired<T extends Element = HTMLElement>(
  root: ParentNode,
  selector: string
): T {
  const node = root.querySelector<T>(selector);

  if (!node) {
    throw new Error(`Required element not found: ${selector}`);
  }

  return node;
}